import React, { useState, useEffect, useContext, useRef } from "react";
import "./HeaderB.css";
import { Row, Col, Navbar, Container, Nav, NavDropdown } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { MainContext } from "../../contexts/MainContext";

import SignModal from "../modals/SignModal";
import apiUrl from "../../utils/ApiConfig";
import alertP from "../../utils/AlertP";
import { TbUserSquareRounded } from "react-icons/tb";
import { MdNotificationsNone } from "react-icons/md";
import { TbCirclePlus2 } from "react-icons/tb";
import { GiExitDoor } from "react-icons/gi";
import MyZayecheh from "../../utils/Modals/MyZayecheh";

export default function HeaderB() {
  let { user, setUser, setResult } = useContext(MainContext);
  const location = useLocation();
  const classRefA = useRef();
  const navigat = useNavigate();
  const [state, setState] = useState(false);

  const [showModal, setShowModal] = useState(false);

  const label = { inputProps: { "aria-label": "Switch demo" } };

  const closemodalHandler = () => {
    setShowModal(false);
  };

  const logOut = () => {
    async function myApp() {
      const res = await fetch(`${apiUrl}/api/User/logout`, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      }).then((res) => {
        if (res.status === 200) {
          setUser(false);
          navigat("/");
        }
      });
    }
    myApp();
  };

  const changeTheme = () => {
    // mainContext.setFlagThem(prev=>!prev)
  };
  // useEffect(()=>{
  //   if(mainContext.flagThem){
  //     document.documentElement.style.setProperty('--them','#278486')
  //     document.documentElement.style.setProperty('--gray','#ffffff')
  //     document.documentElement.style.setProperty('--orange','#64dcd1')
  //     document.documentElement.style.setProperty('--gray2','#ffffff')

  //   }else{

  //     document.documentElement.style.setProperty('--them','#fffba2')
  //     document.documentElement.style.setProperty('--gray','#c1c1c1')
  //     document.documentElement.style.setProperty('--orange','#e9b84f')
  //     document.documentElement.style.setProperty('--gray2','#757272')

  //   }
  //     },[mainContext.flagThem])
  // const refreshToken = () => {
  //   async function myApp() {
  //     const res = await fetch(`${apiUrl}/api/User/refreshToken`, {
  //       method: "GET",
  //       credentials: "include",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //     }).then((res) => {
  //       if (res.ok) {
  //         setUser(true);
  //       } else {
  //         setUser(false);
  //         navigat("/");
  //       }
  //     }).catch(err=>{
  //       console.log(err);
  //       setUser(false)
  //     });
  //   }
  //   myApp();
  // };

  // const intervalId = () => {
  //   setInterval(() => {
  //     refreshToken();
  //   }, 600000);
  // };

  // useEffect(() => {
  //   if(!location.pathname.includes("signup")){
  //     refreshToken();
  //     intervalId();
  //     clearInterval(intervalId);
  //   }
  // }, []);
  //This function toggles the "active" class on an element referenced by classRefA
  const classreffToggle = () => {
    //Check if the element referenced by classRefA contains the "active" class
    if (classRefA.current.classList.contains("rvshow")) {
      //If it does, remove the "active" class
      classRefA.current.classList.remove("rvshow");
    } else {
      //If it doesn't, add the "active" class
      classRefA.current.classList.add("rvshow");
    }
  };

  return (
    <Navbar collapseOnSelect expand="lg" style={{ backgroundColor: "#9933cc" }}>
      <Container className="centerc">
        <Row className="HeaderB-title-row ">
          {" "}
          <Navbar.Brand className="col HeaderB-title-col" style={{ color: "#ffffff" }}>
            AstroGeoMancy <span style={{ fontSize: "8px", opacity: "0.5" }}>V.251103</span>
            <span className="HeaderB-title-span">
              <MdNotificationsNone />
              <TbUserSquareRounded className="HeaderB-title-span-icon" onClick={() => classreffToggle()} />

              <div ref={classRefA} className="HeaderB-title-span-area centercc rvshow " onMouseLeave={() => classRefA.current.classList.add("rvshow")}>
                <TbUserSquareRounded style={{ color: "#9933cc", fontSize: "40px" }} />
                <hr
                  style={{
                    color: "#9933cc",
                    width: "100%",
                    fontSize: "10px",
                    border: "1px solid",
                    opacity: "1",
                  }}
                />
                <ul className="HeaderB-title-span-ul">
                  {user ? (
                    <>
                      <li>نام</li>
                      <li
                        onClick={() => {
                          setState(true);
                          setInterval(() => {
                            setState(false);
                          }, 0.5);
                        }}
                      >
                        زایچه های من
                      </li>
                      <li>اشتراک من</li>
                    </>
                  ) : (
                    <li>ثبت نام | ورود</li>
                  )}
                </ul>

                {user && <span onClick={() => alertP(" از حساب کاربری خود  ذ خارج میشوید ؟", "info", "بله", "خیر", logOut)}>خروج</span>}
              </div>
            </span>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav " backgroundColor="#9933cc" color="##9933cc" style={{ border: "none", width: "50px" }} />
        </Row>

        <Row style={{ width: "100%" }}>
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-autoww" style={{ textcolor: "#ffffff" }}>
              <Link to={"/"} style={{ color: "#ffffff" }}>
                {" "}
                <img src="../../../images/headericon/home.png" alt="" />
                خانه{" "}
              </Link>

              {user && (
                <>
                  <Link to={"/selection"} style={{ color: "#ffffff" }}
                    onClick={() => setResult('')}
                  >
                    <img src="../../../images/headericon/mouse.png" alt="" /> انتخاب شکل
                  </Link>

                  <Link
                    to="#"
                    style={{ color: "#ffffff" }}
                    onClick={() => {
                      setState(true);
                      setInterval(() => {
                        setState(false);
                      }, 0.5);
                    }}
                  >
                    {" "}
                    <img src="../../../images/headericon/book.png" alt="" />
                    زاییچه های من
                    {/* <MyZayecheh state={state} /> */}
                  </Link>
                </>
              )}

              <Link style={{ color: "#ffffff" }}>
                <img src="../../../images/headericon/question.png" alt="" />
                راهنما
              </Link>

              <Link style={{ color: "#ffffff" }}>
                <img src="../../../images/headericon/phone.png" alt="" />
                ارتباط با ما{" "}
              </Link>
              <Link className="header-exit" style={{ color: "#ffffff" }} onClick={() => alertP(" از حساب کاربری خود  ذ خارج میشوید ؟", "info", "بله", "خیر", logOut)}>
                {" "}
                <img src="../../../images/headericon/image_2025-05-29_15-05-15.png" alt="" /> خروج
              </Link>
              {/* 
              {!user && (
                <>
                  <NavDropdown title={<span className="text-white">ورود</span>} id="collapsible-nav-dropdown">
                    <NavDropdown.Item>
                      <Link className="headerb-link" to="/signup" style={{ color: "#9933cc" }}>
                        ثبت نام
                      </Link>{" "}
                    </NavDropdown.Item>
                    <NavDropdown.Item>
                      <Link className="headerb-link" to="/" style={{ color: "#9933cc" }}>
                        ورود
                      </Link>{" "}
                    </NavDropdown.Item>

                    <NavDropdown.Divider />
        
                  </NavDropdown>
                </>
              )} */}
            </Nav>
            <Nav></Nav>
          </Navbar.Collapse>
        </Row>

        {showModal && <SignModal closemodal={closemodalHandler} />}

        {/* (تغییر استیت در دوقسمت انجام میشود) با تغییر استیت  مدال زاییچه باز و بسته میشود */}
        <MyZayecheh state={state} />
      </Container>
    </Navbar>
  );
}

//<InfoIcon className='headerb-icon' style={{ color: '#ffffff' }} />
